import type { z } from 'zod';

import { EmployeeOffBoarding } from '../core';

export const EmployeeOffBoardingFormData = EmployeeOffBoarding;
export type EmployeeOffBoardingFormDataType = z.infer<typeof EmployeeOffBoardingFormData>;
